export default __webpack_public_path__ + "static/media/arrow-up-green.68732f53.svg";